import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import axios from 'axios'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import { Picker } from 'vant';
import { Field } from 'vant';
import { Popup } from 'vant';
import { Button } from 'vant';
import { Dialog } from 'vant';
import { Uploader } from 'vant';
import { CellGroup } from 'vant';
import { Icon } from 'vant';
import { Form } from 'vant';
import { Toast } from 'vant';
import { RadioGroup, Radio } from 'vant';
import { DatetimePicker } from 'vant';
import { Cell } from 'vant';
import { Divider } from 'vant';
import { Calendar } from 'vant';
import { Collapse } from 'vant';
import { CollapseItem,Grid, GridItem, } from 'vant';
import { DropdownMenu, DropdownItem } from 'vant';
import { Checkbox, CheckboxGroup } from 'vant';
import { Tab, Tabs } from 'vant';
Vue.use(Checkbox);
Vue.use(CheckboxGroup);

Vue.use(ElementUI,{size:'mini'});
Vue.prototype.$ELEMENT = { size: 'mini'};

Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(CollapseItem);
Vue.use(Collapse);
Vue.use(Calendar);
Vue.use(Divider);
Vue.use(Cell);
Vue.use(DatetimePicker);
Vue.use(Uploader);
Vue.use(Button);
Vue.use(Dialog);
Vue.use(Popup);
Vue.use(Field);
Vue.use(Picker);
Vue.use(CellGroup);
Vue.use(Icon);
Vue.use(Form);
Vue.use(Toast);
Vue.use(Grid);
Vue.use(GridItem);

Vue.use(Radio);
Vue.use(RadioGroup);

Vue.use(ElementUI);
Vue.prototype.axios = axios
Vue.config.productionTip = false;

// import Vconsole from 'vconsole';
// let vConsole = new Vconsole();
// export default vConsole

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
      document.title = to.meta.title
  }
  next()
})

        //压缩图片
Vue.prototype.$compress=function (fileObj) {
    return new Promise((resolve, reject) => {
        let reader = new FileReader()
        reader.readAsDataURL(fileObj)
        reader.onload = function(e) {
            let image = new Image()     //新建一个img标签（不嵌入DOM节点，仅做canvas操作)
            image.src = e.target.result    //让该标签加载base64格式的原图
            image.onload = function() {    //图片加载完毕后再通过canvas压缩图片，否则图片还没加载完就压缩，结果图片是全黑的
                let canvas = document.createElement('canvas'), //创建一个canvas元素
                    context = canvas.getContext('2d'),    //context相当于画笔，里面有各种可以进行绘图的API
                    imageWidth = image.width / 2,    //压缩后图片的宽度，这里设置为缩小一半
                    imageHeight = image.height / 2,    //压缩后图片的高度，这里设置为缩小一半
                    data = ''    //存储压缩后的图片
                canvas.width = imageWidth    //设置绘图的宽度
                canvas.height = imageHeight    //设置绘图的高度

                //使用drawImage重新设置img标签中的图片大小，实现压缩。drawImage方法的参数可以自行查阅W3C
                context.drawImage(image, 0, 0, imageWidth, imageHeight)
                //使用toDataURL将canvas上的图片转换为base64格式
                data = canvas.toDataURL('image/jpeg');
                canvas.toBlob(function (blob) {
                    const f = new File([blob], fileObj.name,{type: 'image/jpeg'});
                    resolve(f);
                },'image/jpeg')
            }
        }
    })

}